module.exports = __webpack_public_path__ + "img/aiIcon-asr.ef07e427.svg";